import React from "react";

function HeadRegresar(props) {

    return (
        <div className="grid grid-cols-2 gap-4">
            <div><h5 className="font-bold uppercase text-white">{props.titulo}</h5></div>
            <div className="row justify-content-end">
                <div className="col-lg-2">
                    <button className="btn btn-light text-shadow btn-sm shadow  rounded"
                        onClick={props.history.goBack}>
                    <i className="fas fa-arrow-left"></i> Regresar
                </button>
                </div>
                
            </div>
        </div>
    );
}

export default HeadRegresar;
